import { Box, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { FormattedMessage } from 'intl';
import { ReportTranslationKeys } from 'intl/keys';

import { useInputForm } from 'components/dataCreationForms/withInputForm';
import { ReportAdditionalInformationField } from 'shared/domain/report/types/model/common';
import { REPORT_FILE_INFO_CHIP_TOOLTIP_LABELS } from '../reportTooltipLabels';
import { ReportFilterChip } from './ReportFilterChip';

export function ReportParticipantPersonalDataSection(): ReactElement {
  const { values, setValues } = useInputForm();

  const toggle = (key: ReportAdditionalInformationField) => {
    setValues(key, !values[key]);
  };

  return (
    <Box data-qa='report_participant_personal_data' sx={{ mt: '-6px' }}>
      <Typography
        variant='caption'
        component='div'
        color='text.secondary'
        sx={{ mb: 0.75, fontWeight: 500, lineHeight: 1.4375 }}
      >
        <FormattedMessage
          id={ReportTranslationKeys.participantPersonalDataLabel}
        />
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <ReportFilterChip
          selected={values.showPhoneNumbers}
          labelId={ReportTranslationKeys.fileInfoChipPhoneNumbers}
          tooltipId={REPORT_FILE_INFO_CHIP_TOOLTIP_LABELS.phoneNumbers}
          data-qa='report_participant_show_phone_numbers'
          onClick={() =>
            toggle(ReportAdditionalInformationField.showPhoneNumbers)
          }
        />
        <ReportFilterChip
          selected={values.showUserEmails}
          labelId={ReportTranslationKeys.fileInfoChipUserEmails}
          tooltipId={REPORT_FILE_INFO_CHIP_TOOLTIP_LABELS.userEmails}
          data-qa='report_participant_show_user_emails'
          onClick={() =>
            toggle(ReportAdditionalInformationField.showUserEmails)
          }
        />
      </Box>
    </Box>
  );
}
